export const ifThenElseMultipleConditions = (defaultValue, ...args) => {
  for (let i = 0; i < args?.length; i += 2) {
    if (args[i]) {
      return args[i + 1];
    }
  }
  return defaultValue; // Trả về giá trị mặc định nếu không có điều kiện nào khớp
}